import {
  Box,
  IconButton,
  Input,
  InputAdornment,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { AmountTextFields } from "../../style/styleComponents/StyledFinancialSnapshot";
import { getColor } from "../../style/color/color";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ReactComponent as EditIcon } from "../../assets/icon/editIcon.svg";
import { memo } from "react";
import { String } from "../../constants/Strings";
import { fonts } from "../../style/fonts/fonts";

const FinancialBox = ({
  title,
  Icon,
  editVisible,
  onEditClick,
  setIsClick,
  value,
  handleChange,
  readOnly,
  toolTip,
  tooltipText,
  placeholderVal,
  errorChecks,
  belowText,
  asterrisk,
  requireFeilds,
}) => {
  const displayValue = value === "" ? "" : value;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mt: "30px",
        mb: "30px",
      }}
    >
      <Stack
        sx={{
          width: "180px",
          display: "flex",

          ml: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              p: "4px",
              borderRadius: 50,
              backgroundColor: getColor.NeutralLightN60,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Icon
              style={{
                width: "20px",
                height: "20px",
                borderRadius: 50,
              }}
            />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography sx={{ ml: "5px", marginRight: "-5px" }}>
              {title}
            </Typography>
            {toolTip && (
              <Tooltip title={tooltipText} sx={{ ml: 0 }} enterTouchDelay={0}>
                <IconButton sx={{ ml: 0 }}>
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </Box>
        {editVisible && (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                color: getColor.SecondarySummerSky,
                fontSize: 10,
                fontFamily: fonts.manrope,
                fontWeight: "700",
              }}
              onClick={() => {
                onEditClick(title);
                setIsClick(true);
              }}
            >
              {String.Dashboard.mainDashboard.EditDetails}
            </Typography>
            <IconButton
              onClick={() => {
                onEditClick(title);
                setIsClick(true);
              }}
            >
              <EditIcon />
            </IconButton>
          </Box>
        )}
      </Stack>
      <Box
        sx={{
          width: "100%",
          ml: "45px",
          textAlign: "center",
        }}
      >
        <Input
          sx={{
            ...AmountTextFields,

            borderColor: errorChecks === true ? "red" : "",
          }}
          type="number"
          required={requireFeilds}
          disableUnderline={true}
          value={displayValue}
          onChange={(e) => {
            let newValue = e.target.value;

            if (newValue === "" || !isNaN(newValue)) {
              handleChange(newValue);
            }
          }}
          placeholder={placeholderVal}
          readOnly={readOnly}
          inputProps={{
            sx: {
              fontSize: 13,
              fontFamily: fonts.manrope,
              fontWeight: "700",
              textAlign: "right",
            },
            onKeyDown: (e) => {
              if (e.key === "Backspace" && displayValue === 0) {
                handleChange("");
              }
            },
          }}
          error={asterrisk}
          startAdornment={<InputAdornment position="start">₹</InputAdornment>}
          onFocus={(e) => {
            if (e.target.value === "0") {
              handleChange("");
            }
          }}
        />
        {asterrisk && (
          <span
            style={{
              color: getColor.red,
              fontSize: 18,
              fontFamily: fonts.manrope,
              fontWeight: "700",
            }}
          >
            *
          </span>
        )}

        <Typography
          sx={{
            color: getColor.NeutralsMidN200,
            fontSize: 11,
            fontFamily: fonts.manrope,
            fontWeight: "500",
            mt: "4px",
          }}
        >
          {belowText}
        </Typography>
      </Box>
    </Box>
  );
};

export default memo(FinancialBox);
